import { useIntl } from 'react-intl';

export interface TranslatedAttributeLabelProps {
  attributeCode: string;
  attributeValue: string;
}

export function TranslatedAttributeLabel({ attributeCode, attributeValue }: TranslatedAttributeLabelProps) {
  const intl = useIntl();

  const translateAttributeValue = () => {
    switch (attributeCode) {
      case 'chnFulfillmentMethod':
        return intl.formatMessage({
          id: `fulfillment.method.${attributeValue}`,
          defaultMessage: attributeValue,
        });
      case 'styNumber':
        return `(${attributeValue})`;
      case 'prdNumber':
        return attributeValue;
      case 'prdCategory':
        return intl.formatMessage({
          id: `product.categories.${attributeValue}`,
          defaultMessage: attributeValue,
        });
      case 'chnCountry':
        return intl.formatDisplayName(attributeValue, { type: 'region' }) ?? attributeValue;
      default:
        return attributeValue;
    }
  };

  return <span>{translateAttributeValue()}</span>;
}
